module.exports = __webpack_public_path__ + "static/img/10016 (1).5733766.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10016 (1).webp
// module id = BT48
// module chunks = 14